import styled from 'styled-components';

import {media} from '~/shared/theme/media';
import {flexColumn, flexColumnCenterVertically, flexSpace} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {body16Bold, body18Bold} from '~/shared/theme/typography';

export const Wrapper = styled.div`
  margin-top: 24px;
  ${media.minLargeMobile`
    margin-top: 8px;
  `}
`;

export const InnerWrapper = styled.div`
  flex: 1;
  ${flipOnLTR`
    padding-left: 24px;
  `}

  &:last-child {
    padding: 0;
  }
`;

export const MobileInnerWrapper = styled.div`
  ${flexColumnCenterVertically};
  flex: 1;
  padding: 20px 0;
  border-radius: 12px;
  box-shadow: ${({theme}) => theme.shadows.elevationCard};
  background-color: ${({theme}) => theme.userReport.moneyCardDetails.background};
`;

export const MoneyCardDetailWrapper = styled.div`
  ${({spaceTop}) => spaceTop && 'margin-top: 38px;'}
  ${flexColumn};
  ${flexSpace};
  flex-direction: row;
  flex: 1 0 auto;
  margin: 0 auto;
  width: 100%;
  min-height: 95px;

  &:last-child {
    margin-bottom: 25px;
  }
`;

export const Title = styled.div`
  ${body18Bold};
  margin-bottom: 16px;
  color: ${({theme}) => theme.userReport.transactionTable.background.header};
  ${({isMobile}) =>
    isMobile &&
    `
    margin-top: 15px;
    margin-bottom: 15px;
    ${body16Bold};
  `}
`;
